/**
 * Portuguese (Português) Language File
 * 
 * This file contains all Portuguese translations for the application.
 */

export const pt = {
  // Language info
  language: {
    code: 'pt',
    name: 'Português',
    flag: '🇧🇷',
  },

  // Common/General translations
  common: {
    welcome: 'Bem-vindos',
    back: 'Voltar',
    backTo: 'Voltar para',
    next: 'Próximo',
    previous: 'Anterior',
    continue: 'Continuar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    close: 'Fechar',
    loading: 'Carregando',
    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',
    yes: 'Sim',
    no: 'Não',
    ok: 'OK',
    placeholderNote: '⚠️ Conteúdo placeholder — pendente de definição pela equipe Fe en Juego.',
  },

  // Home Page
  home: {
    title: 'Bem-vindos',
    subtitle: 'Diversão, desafios e Bíblia em cada partida.',
    chooseGame: 'Escolha um jogo',
    heroSubtitle: 'Jogos interativos que fortalecem a fé e conectam comunidades',
    exploreGames: 'Explorar Jogos',
    ourGames: 'Nossos Jogos',
    conectadosDescription: 'Explore categorias de Sabedoria e Aliança com perguntas projetadas para aprofundar seu conhecimento.',
    playGame: 'Jogar',
    followUs: 'Conecte-se conosco',
    copyright: '© 2025 Fe en Juego. Todos os direitos reservados.',
  },

  // Games Catalog
  games: {
    status: {
      available: 'Disponível',
      preSale: 'Pré-venda',
      comingSoon: 'Em breve',
    },
    actions: {
      buy: 'Comprar',
      preOrder: 'Reservar',
      playNow: 'Jogar agora',
      howToPlay: 'Como jogar',
      comingSoon: 'Em breve',
    },
    conecta2: {
      name: 'Conecta2',
      subtitle: 'Jogo de perguntas e respostas',
      description: 'Explore categorias de Sabedoria e Aliança com perguntas projetadas para aprofundar seu conhecimento.',
    },
    bibliquien: {
      name: 'BibliQuien?',
      subtitle: 'Jogo de descarte e personagens bíblicos',
      description: 'Faça as perguntas certas, descarte bem e descubra o personagem bíblico secreto do seu oponente.',
    },
    logoYa: {
      name: 'Logo YA!',
      subtitle: 'Desafio de velocidade visual',
      description: 'Identifique rapidamente símbolos e conceitos da fé em um emocionante jogo de agilidade mental.',
    },
  },

  // Resources Section
  resources: {
    title: 'Recursos para Culto Jovem',
    subtitle: 'Materiais e recursos para download para líderes e equipes',
    download: 'Baixar',
    downloadLabel: 'Baixar',
    comingSoon: 'Em breve',

    // Placeholder resources
    placeholders: {
      guides: {
        title: 'Guias do Jogo',
        description: 'Instruções completas e guias passo a passo para facilitar o jogo em seu grupo.',
      },
      presentations: {
        title: 'Apresentações PPT',
        description: 'Apresentações prontas para usar em suas reuniões e atividades em grupo.',
      },
      additionalMaterial: {
        title: 'Material Adicional',
        description: 'PDFs, planilhas e outros recursos complementares para enriquecer a experiência.',
      },
    },
  },

  // Links of Interest Section
  links: {
    title: 'Links de Interesse',
    subtitle: 'Recursos e sites úteis para a comunidade adventista',
    visit: 'Visitar',
    visitLabel: 'Visitar site',

    // Individual links
    items: {
      iasd: {
        title: 'Página IASD',
        description: 'Site oficial da Igreja Adventista do Sétimo Dia',
      },
      noticiasIasd: {
        title: 'Notícias IASD',
        description: 'Portal de notícias adventistas',
      },
      whatsappUu: {
        title: 'Canal WhatsApp UU',
        description: 'Canal oficial do WhatsApp União Uruguaia',
      },
      feliz7play: {
        title: 'Feliz7Play',
        description: 'Plataforma de conteúdo audiovisual adventista',
      },
      videosIasd: {
        title: 'Vídeos IASD',
        description: 'Canal oficial do YouTube da IASD América do Sul',
      },
      radioNt: {
        title: 'Nuevo Tiempo UY',
        description: 'Rádio Nuevo Tiempo Uruguai ao vivo',
      },
      materialesIasd: {
        title: 'Materiais IASD',
        description: 'Centro de downloads de materiais adventistas',
      },
      paraElSabado: {
        title: 'Para o Sábado',
        description: 'Materiais especiais para suas atividades sabáticas',
      },
      galeriaImagenes: {
        title: 'Galeria de Imagens',
        description: 'Galeria de imagens cristãs para uso ministerial',
      },
      leccionJovenes: {
        title: 'Lição Jovens',
        description: 'Lições e materiais para classes de jovens',
      },
      jaMateriales: {
        title: 'Materiais JA',
        description: 'Materiais e informações para Jovens Adventistas',
      },
      accionJoven: {
        title: 'Revista Ação Jovem',
        description: 'Revista trimestral para jovens adventistas',
      },
      conquistadores: {
        title: 'Desbravadores',
        description: 'Materiais e informações do clube de Desbravadores',
      },
      ministerioNino: {
        title: 'Ministério da Criança',
        description: 'Recursos para o ministério infantil',
      },
      recursosBiblicos: {
        title: 'Recursos Bíblicos',
        description: 'Materiais e recursos para o estudo da Bíblia',
      },
      meditaciones2025: {
        title: 'Meditações 2025',
        description: 'Meditações para o pôr do sol 2025',
      },
      seme: {
        title: '7me',
        description: 'Aplicativo oficial para membros e amigos Adventistas',
      },
      probadVed: {
        title: 'Provai e Vede',
        description: 'Vídeos sobre mordomia cristã',
      },
    },
  },

  // Footer
  footer: {
    copyright: '© 2025 Fe en Juego. Todos os direitos reservados.',
  },

  // Conecta2 Game
  conectados: {
    // Main page
    title: 'Conecta2',
    playing: 'Você está jogando',
    subtitle: 'Jogo de perguntas e respostas',
    selectCategory: 'Selecione uma categoria',

    // Access control
    access: {
      title: 'Acesso a Conecta2',
      message: 'Insira o código que acompanha seu jogo.',
      placeholder: 'XXXXXX',
      submit: 'Acessar',
      invalidCode: 'Código de acesso incorreto. Por favor, verifique o código nas instruções do jogo.',
      emptyCode: 'Por favor, insira um código de acesso.',
      success: 'Acesso concedido! Redirecionando...',
      infoTitle: 'Onde encontro o código?',
      infoText: 'O código de acesso está localizado nas instruções incluídas nas instruções do jogo.',
    },

    // Game controls
    startGame: 'Iniciar Jogo',
    endGame: 'Terminar Jogo',
    resetGame: 'Reiniciar Jogo',
    newGame: 'Novo Jogo',

    // Categories
    categories: {
      sabiduria: {
        title: 'Sabedoria',
        description: 'Teste seu conhecimento em diferentes áreas',
        alt: 'Sabedoria - Teste seu conhecimento de lugares, variedades e personagens',
      },
      alianza: {
        title: 'Aliança',
        description: 'Explore o pacto, a unidade e a coragem',
        alt: 'Aliança - Explore temas de pacto, unidade e coragem',
      },
    },

    // Subcategories
    subcategories: {
      // Sabiduria
      lugares: {
        title: 'Lugares',
        description: 'Lugares e localizações bíblicas',
      },
      variedades: {
        title: 'Variedades',
        description: 'Diferentes aspectos da fé',
      },
      personajes: {
        title: 'Personagens',
        description: 'Personagens e figuras bíblicas',
      },

      // Alianza
      'si-nosotros': {
        title: 'Se Nós',
        description: 'Nosso papel no pacto de Deus',
      },
      coincidimos: {
        title: 'Concordamos',
        description: 'Encontrar pontos em comum na fé',
      },
      arriesgamos: {
        title: 'Arriscamos',
        description: 'Tomar riscos por nossas crenças',
      },
    },

    // Question page
    question: {
      title: 'Pergunta',
      question: 'Pergunta',
      prompt: 'Instrução',
      answer: 'Resposta',
      options: 'Opções de resposta:',
      whichVerse: 'Qual versículo você usaria?',
      reference: 'Referência bíblica:',
      showAnswer: 'Mostrar Resposta',
      hideAnswer: 'Ocultar Resposta',
      endTurn: 'Terminar Turno',
      nextQuestion: 'Próxima Pergunta',
      loading: 'Carregando pergunta...',
      noQuestions: 'Não há mais perguntas disponíveis',
      error: 'Erro ao carregar perguntas',
      tryAgain: 'Tentar Novamente',
      trueOption: 'Verdadeiro',
      falseOption: 'Falso',
    },

    // Stats
    stats: {
      questionsAnswered: 'Perguntas respondidas:',
      totalQuestions: 'Total de perguntas:',
      questionsRemaining: 'Perguntas restantes:',
      resetQuestions: 'Reiniciar Perguntas',
      categoryStats: 'Estatísticas desta subcategoria',
    },

    // Completion
    completion: {
      congratulations: 'Parabéns!',
      allQuestionsCompleted: 'Você respondeu todas as perguntas desta categoria!',
      questionsCompleted: 'Perguntas completadas:',
      returnToConectados: 'Voltar para Conecta2',
      returnToCategories: 'Voltar para Categorias',
    },

    // Footer
    footer: {
      quote: '"É melhor ser dois do que um, porque ambos podem ajudar-se mutuamente a alcançar o sucesso."',
      reference: 'Eclesiastes 4:9 (NVT)',
    },

    // PDF Modal (How to Play)
    pdfModal: {
      title: 'Como Jogar',
      mobileTitle: 'Ver Instruções PDF',
      mobileDescription: 'Para uma melhor experiência em dispositivos móveis, você pode abrir o PDF em uma nova aba ou baixá-lo.',
      openPDF: 'Abrir PDF',
      downloadPDF: 'Baixar PDF',
    },
  },

  // Error messages
  errors: {
    general: 'Ocorreu um erro',
    notFound: 'Não encontrado',
    categoryNotFound: 'Categoria não encontrada',
    subcategoryNotFound: 'Subcategoria não encontrada',
    questionsNotFound: 'Nenhuma pergunta encontrada',
    loadingFailed: 'Erro ao carregar',
    networkError: 'Erro de conexão',
  },

  // Success messages
  success: {
    saved: 'Salvo com sucesso',
    deleted: 'Excluído com sucesso',
    updated: 'Atualizado com sucesso',
  },

  // Time and dates
  time: {
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'dias',
    weeks: 'semanas',
    months: 'meses',
    years: 'anos',
  },

  // Accessibility
  a11y: {
    menu: 'Menu',
    close: 'Fechar',
    open: 'Abrir',
    previous: 'Anterior',
    next: 'Próximo',
    loading: 'Carregando',
  },

  // Thank You / Payment Confirmation Page
  gracias: {
    // Success state
    success: {
      title: 'Obrigado pela sua compra!',
      message: 'Seu pagamento foi recebido corretamente. Envie-nos o comprovante pelo WhatsApp junto com:',
      info1: 'Nome completo',
      info2: 'Endereço',
      info3: 'Telefone',
      info4: 'Forma de entrega (retirada ou envio)',
      paymentCode: 'Código de pagamento:',
      whatsappButton: 'Enviar pelo WhatsApp',
    },

    // Pending state
    pending: {
      title: 'Seu pagamento está pendente',
      message: 'Mercado Pago está revisando sua transação.',
      submessage: 'Notificaremos você quando o pagamento for confirmado.',
      paymentCode: 'Código de transação:',
    },

    // Failure state
    failure: {
      title: 'O pagamento não pôde ser concluído',
      message: 'Houve um problema ao processar sua compra.',
      submessage: 'Você pode tentar novamente ou nos contatar pelo WhatsApp se precisar de ajuda.',
      retryButton: 'Tentar novamente',
      contactButton: 'Contatar pelo WhatsApp',
    },

    // Waiting state (no params)
    waiting: {
      title: 'Aguardando informações',
      message: 'Confirme seu pagamento por Mercado Pago.',
      submessage: 'Avisanos por WhatsApp quando se confirme o pagamento.',
    },
  },

  // Conecta2 Product Landing Page
  conecta2Product: {
    // SEO & Meta
    meta: {
      title: 'Conecta2 — Jogo de tabuleiro cristão | Fe en Juego',
      description: 'Conecta2: jogo de tabuleiro cristão uruguaio. Ideal para famílias, jovens e igrejas. Preço de lançamento e reservas pelo WhatsApp.',
    },

    // Hero Section
    hero: {
      launchBadge: 'Preço',
      title: 'Lançamento oficial do Conecta2!',
      subtitle: 'Jogo de tabuleiro cristão para famílias, jovens e igrejas.',
      imageAlt: 'Caixa Conecta2 sobre a mesa',
    },

    // Price Section
    price: {
      title: 'Preço',
      subtitle: 'Escolha seu método de pagamento preferido',
      mercadopago: {
        label: 'MercadoPago',
        interestFree: '(Em até 12 parcelas sem juros)',
        price: 940,
        detail: 'Até 12 parcelas',
      },
      transferencia: {
        label: 'Transferência / Dinheiro',
        price: 850,
        originalPrice: 940,
        discount: '10% OFF',
        detail: 'Pagamento único',
      },
      selected: 'Selecionado',
      reserveButton: 'Reservar pelo WhatsApp',
      paymentInfoLink: 'Consultar métodos de pagamento e dados de conta pelo WhatsApp',
      whatsappMessage: {
        reserve: `Olá! Quero reservar o Conecta2.
Quantidade: 
Pagamento: {paymentMethod}
Nome: 
Endereço (se envio): 
Vocês têm unidades disponíveis?`,
        paymentInfo: `Olá! Gostaria de saber:
• Todos os métodos de pagamento disponíveis
• Dados da conta para transferência
• Informações sobre MercadoPago

Obrigado!`,
      },
    },

    // What's Included Section
    includes: {
      title: 'O que inclui o Conecta2?',
      items: [
        'Tabuleiro',
        'Peças para até 10 jogadores',
        'Talão "Conexão"',
        'Instruções',
        'Acesso online a perguntas e desafios',
      ],
    },

    // How to Play Section
    howToPlay: {
      title: 'Como jogar (em 3 passos)',
      steps: [
        'Escolha sua peça e coloque-a no início.',
        'O jogador escolhe um conectado e resolve a atividade.',
        'O primeiro que chegar à casa final e resolver, ganha.',
      ],
    },

    // Gallery Section
    gallery: {
      title: 'Galeria de fotos',
      images: [
        { alt: 'Jogo completo Conecta2' },
        { alt: 'Tabuleiro e caixa do Conecta2' },
        { alt: 'App com perguntas e desafios' },
        { alt: 'Família jogando Conecta2' },
        { alt: 'Detalhe das peças do jogo' },
        { alt: 'Talão de conexão' },
        { alt: 'Instruções do jogo' },
        { alt: 'Jogadores em ação' },
        { alt: 'Componentes do jogo' },
      ],
    },

    // FAQ Section
    faq: {
      title: 'Perguntas frequentes',
      items: [
        {
          question: 'Como pago?',
          answer: 'Coordenamos pelo WhatsApp. Aceitamos transferências, dinheiro e MercadoPago (até 12 parcelas).',
        },
        {
          question: 'Posso comprar no atacado?',
          answer: 'Sim — escreva-nos pelo WhatsApp para ver preços por quantidade.',
        },
        {
          question: 'Vocês fazem envios?',
          answer: 'Sim, enviamos para todo o país através de agências de encomenda.',
        },
        {
          question: 'Quanto custa o envio?',
          answer: 'O custo depende da localidade e do método de envio escolhido. 💵 O cliente paga o envio ao receber ou retirar o pacote.',
        },
        {
          question: 'Como é coordenado o envio?',
          answer: 'Após confirmar a compra, coordenamos tudo pelo WhatsApp (método de envio, agência, horários, etc.) para que chegue da forma mais rápida e conveniente possível.',
        },
      ],
    },

    // Testimonial Section
    testimonial: {
      title: 'Fe en Juego',
      text: 'Jogos que unem a fé e a família',
      quote: '"Lâmpada para os meus pés é a tua palavra..." — Salmo 119:105',
    },
  },

  // BibliQuien? — Página do Jogador
  bibliquienGame: {
    hero: {
      title: 'Como jogar BibliQuien?',
      subtitle: 'Um jogo onde cada pergunta te aproxima da resposta... ou te afasta dela.',
      imageAlt: 'BibliQuien? — Jogo bíblico da Fe en Juego',
    },
    badges: {
      physical: 'Jogo Físico',
      status: 'Em breve',
    },
    actions: {
      buy: 'Ver produto',
      instructions: 'REGRAS',
    },
    overview: {
      eyebrow: 'O jogo',
      title: 'De um relance',
      subtitle: 'Um jogo de perguntas, dedução e estratégia para 2 jogadores. Descubra o personagem bíblico secreto do seu oponente antes que ele descubra o seu.',
      facts: [
        { title: 'Jogadores', text: '2' },
        { title: 'Duração', text: '15 min aprox.' },
        { title: 'Conteúdo', text: '72 cartas · só cartas' },
      ],
    },
    classic: {
      eyebrow: 'COMO JOGAR',
      title: 'As regras base do BibliQuién',
      subtitle: 'Tudo o que você precisa saber para jogar.',
      preparation: {
        title: 'Preparação',
        steps: [
          { title: 'Escolha seu baralho', description: 'Cada jogador escolhe um baralho, azul ou amarelo, e coloca todas as suas cartas viradas para cima à sua frente.' },
          { title: 'Escolha o personagem secreto', description: 'Cada jogador escolhe uma carta do baralho bordô sem mostrá-la ao oponente. Esse será seu personagem secreto.' },
        ],
      },
      howToPlay: {
        title: 'Como jogar',
        steps: [
          { title: 'Faça perguntas', description: 'Em turnos, cada jogador faz uma pergunta sobre o personagem secreto do oponente. As perguntas devem poder ser respondidas apenas com "sim" ou "não".' },
          { title: 'Descarte personagens', description: 'De acordo com as respostas recebidas, descarte das suas cartas viradas para cima os personagens que já não podem ser o personagem secreto do seu oponente.' },
          { title: 'Arrisque!', description: 'Quando você achar que sabe quem é o personagem secreto, pode tentar adivinhá-lo em vez de fazer uma pergunta.' },
        ],
      },
      howToWin: {
        title: 'Como ganhar',
        success: 'Se você acertar o personagem secreto → você vence a partida!',
        fail: 'Se errar → você perde a partida.',
        closing: 'Você consegue fazer as perguntas certas e descobrir o personagem do seu oponente antes que ele descubra o seu?',
      },
    },

    modes: {
      eyebrow: 'Modos adicionais',
      title: 'Pronto para jogar diferente?',
      subtitle: 'Mantenha as regras base e adicione desafios especiais à partida.',
      items: [
        {
          id: 'desafio-biblico',
          title: 'Desafio Bíblico',
          tagline: 'Você acha que sabe quem é? Antes de ganhar, mostre o quanto sabe sobre ele.',
          rule: {
            title: 'Regra adicional',
            text: 'Ao tentar adivinhar o personagem, você deve dizer corretamente o nome dele e mencionar um fato ou história bíblica relacionada a ele.',
          },
          example: { quote: '“É Moisés… o que abriu o Mar Vermelho.”' },
          outcomes: [
            { status: 'win', text: 'Personagem correto + dado bíblico correto → você vence a partida!' },
            { status: 'continue', text: 'Personagem correto + dado incorreto → você não vence e a partida continua.' },
            { status: 'lose', text: 'Personagem incorreto → você perde a partida.' },
          ],
          closing: 'Este modo adiciona um desafio de conhecimento bíblico e ajuda a lembrar das histórias da Bíblia enquanto você joga.',
        },
        {
          id: 'pregunta-prohibida',
          title: 'Pergunta Proibida',
          tagline: 'Quer deixar a partida mais difícil? Algumas perguntas fáceis ficam proibidas.',
          rule: {
            title: 'Regra adicional',
            text: 'Durante toda a partida, é proibido perguntar diretamente sobre o gênero do personagem, sua aparência ou vestimenta e o Testamento em que ele aparece.',
          },
          forbidden: {
            title: 'Você não pode perguntar',
            items: ['É homem?', 'Tem barba?', 'Usa uma coroa?', 'Aparece no Antigo Testamento?'],
          },
          alternatives: {
            title: 'Em vez disso, pergunte assim',
            items: ['É um rei?', 'É um profeta?', 'Fez algum milagre?', 'Teve um encontro com Jesus?', 'Foi líder do povo de Israel?'],
          },
          closing: 'Este modo te obriga a pensar melhor nas suas perguntas e a usar seus conhecimentos bíblicos para encontrar pistas.',
        },
        {
          id: 'batalla-biblica',
          title: 'Batalha Bíblica',
          tagline: 'São vários jogadores? Formem equipes e transformem BibliQuien em uma batalha de conhecimento e estratégia.',
          preparation: {
            title: 'Preparação',
            steps: [
              { title: 'Formem duas equipes', description: 'Dividam os jogadores em duas equipes.' },
              { title: 'Escolha um representante', description: 'Cada equipe escolhe um jogador para representá-la durante a rodada.' },
              { title: 'Prepare os segredos', description: 'Os representantes preparam seus personagens secretos como no modo clássico.' },
            ],
          },
          howToPlay: {
            title: 'Como jogar',
            steps: [
              { title: 'Turnos dos representantes', description: 'Os representantes se alternam para fazer perguntas à equipe rival.' },
              { title: 'A equipe opina', description: 'A equipe pode conversar e sugerir perguntas, mas o representante decide finalmente qual fazer.' },
              { title: 'Tente adivinhar', description: 'Quando uma equipe achar que sabe qual é o personagem secreto do rival, pode tentar adivinhá-lo.' },
            ],
          },
          howToWin: {
            title: 'Como vencer',
            success: 'A primeira equipe que descobrir corretamente o personagem secreto da equipe rival vence a rodada.',
          },
          closing: 'Este modo permite que todos participem, combinando o conhecimento da equipe com a estratégia do representante.',
        },
      ],
    },

    combine: {
      eyebrow: 'Combine modos',
      title: 'Crie o seu próprio desafio',
      subtitle: 'Você pode combinar os modos como quiser e criar uma partida diferente a cada vez.',
      examples: [
        { left: 'Desafio Bíblico', right: 'Pergunta Proibida' },
        { left: 'Batalha Bíblica', right: 'Desafio Bíblico' },
      ],
    },

    faq: {
      title: 'Perguntas frequentes',
      subtitle: 'Respondemos as dúvidas mais comuns sobre o jogo.',
      items: [
        {
          question: 'Quantos jogadores participam?',
          answer: 'BibliQuién? é projetado para 2 jogadores.',
        },
        {
          question: 'O que inclui a caixa?',
          answer: 'A caixa inclui 72 cartas: os baralhos de cada jogador (azul e amarelo) e o baralho de personagens secretos (bordô). Não há tabuleiro nem peças.',
        },
        {
          question: 'Quanto dura uma partida?',
          answer: 'Uma partida dura aproximadamente 15 minutos.',
        },
        {
          question: 'O que acontece se eu tentar adivinhar e errar?',
          answer: 'Se um jogador tentar adivinhar o personagem secreto e errar, perde automaticamente a partida.',
        },
      ],
    },
    cta: {
      title: 'Tem interesse em BibliQuien?',
      text: 'Em breve disponível. Consulte pelo WhatsApp para receber novidades.',
      buttonText: 'Ver informações do produto',
    },
  },

  // BibliQuien? — Página Comercial
  bibliquienProduct: {
    hero: {
      title: 'BibliQuien?',
      subtitle: 'Você consegue descobrir qual personagem bíblico seu oponente escolheu antes que ele descubra o seu? Faça perguntas, elimine personagens e descubra quem é!',
      imageAlt: 'BibliQuien? — Cartas do jogo',
      whatsAppBtn: 'Comprar pelo WhatsApp',
    },

    badges: {
      type: 'Jogo de Cartas',
      status: 'Disponível',
    },

    price: {
      title: 'Tenha seu BibliQuien?',
      subtitle: 'Um jogo rápido e divertido para testar seus conhecimentos sobre os personagens da Bíblia.',
      statusBadge: 'Preço',
      amountText: '$790',
      amountSubtext: 'MercadoPago $870',
      features: [
        '72 cartas no total',
        '24 personagens bíblicos',
        '2 baralhos para jogar: azul e amarelo',
        'Baralho de personagens secretos: bordô',
        'Para 2 jogadores',
      ],
      whatsAppMessage: 'Olá! Tenho interesse no BibliQuien. Como posso comprar?',
      whatsAppBtn: 'Comprar pelo WhatsApp',
      footerNote: 'A compra e o envio são combinados pelo WhatsApp.',
    },

    includes: {
      title: 'O que vem no BibliQuien?',
      subtitle: 'Tudo o que você precisa para jogar e se divertir descobrindo personagens bíblicos.',
      item1: '72 cartas no total',
      item2: '24 personagens bíblicos',
      item3: 'Cartas com três cores: azul, amarelo e bordô',
    },

    gallery: {
      title: 'Conheça o BibliQuien?',
      subtitle: 'Veja as cartas e descubra um pouco mais sobre o jogo.',
      item1: 'Baralho azul e baralho amarelo do BibliQuien?',
      item2: 'Verso das cartas — azul, amarelo e bordô',
      item3: 'Baralho de personagens e carta de exemplo',
    },

    faq: {
      title: 'Perguntas frequentes',
      subtitle: 'Tire suas dúvidas antes de comprar seu BibliQuien.',
      items: [
        {
          question: 'Como se joga?',
          answer: 'Cada jogador recebe um personagem bíblico secreto. Em cada rodada, vocês fazem perguntas para eliminar personagens até descobrir qual foi escolhido pelo oponente. Quem descobrir primeiro, ganha!',
        },
        {
          question: 'Para quantas pessoas é o jogo?',
          answer: 'BibliQuien foi feito para 2 jogadores.',
        },
        {
          question: 'Quais personagens estão no jogo?',
          answer: 'O jogo inclui 24 personagens bíblicos diferentes, escolhidos para trazer variedade e testar seus conhecimentos sobre a Bíblia.',
        },
        {
          question: 'O que vem na caixa?',
          answer: 'A caixa contém as 72 cartas do jogo: o baralho azul, o baralho amarelo e o baralho de personagens secretos (bordô). Não inclui tabuleiro nem peças.',
        },
        {
          question: 'Vocês fazem entregas?',
          answer: 'Sim! Fazemos envios para todo o país. Os detalhes da entrega são combinados no momento da compra.',
        },
      ],
    },
  },

  // Logo YA! — Página do Jogador
  logoYaGame: {
    hero: {
      title: 'Logo YA!',
      subtitle: 'Identifique rapidamente símbolos e conceitos da fé em um emocionante jogo de velocidade mental.',
      imageAlt: 'Logo YA! — Jogo de velocidade visual da Fe en Juego',
    },
    badges: {
      physical: 'Jogo Físico',
      status: 'Em breve',
    },
    actions: {
      buy: 'Ver produto',
      instructions: 'Como jogar',
    },
    overview: {
      title: 'Sobre Logo YA!',
      subtitle: '[PLACEHOLDER] Descrição geral do jogo pendente de definição.',
      cards: {
        conceptTitle: 'Conceito',
        conceptText: '[PLACEHOLDER] Um jogo de agilidade visual e identificação de símbolos.',
        playersTitle: 'Jogadores',
        playersText: '[PLACEHOLDER] 2 a 8 jogadores.',
        durationTitle: 'Duração',
        durationText: '[PLACEHOLDER] 20 a 45 minutos por partida.',
      },
    },
    instructions: {
      title: 'Como jogar',
      subtitle: '[PLACEHOLDER] As instruções definitivas estão em processo.',
      steps: [
        { title: 'Preparação', description: '[PLACEHOLDER] Descrição de como preparar o jogo antes de começar.' },
        { title: 'Desenvolvimento', description: '[PLACEHOLDER] Descrição de como ocorre a partida.' },
        { title: 'Como ganhar', description: '[PLACEHOLDER] Condição de vitória pendente de definir.' },
      ],
    },
    modes: {
      title: 'Modos de jogo',
      subtitle: '[PLACEHOLDER] Os modos de jogo definitivos estão em processo de definição.',
      items: [
        { title: 'Modo Clássico', description: '[PLACEHOLDER] Descrição do modo clássico.' },
        { title: 'Modo Cronometrado', description: '[PLACEHOLDER] Descrição do modo contra-relógio.' },
        { title: 'Modo Equipes', description: '[PLACEHOLDER] Descrição do modo por equipes.' },
      ],
    },
    expansions: {
      title: 'Recursos e expansões',
      subtitle: '[PLACEHOLDER] Materiais adicionais e expansões futuras.',
      downloadsTitle: 'Folhas imprimíveis',
      downloadsText: '[PLACEHOLDER] Em breve disponíveis para download.',
      futureTitle: 'Expansões futuras',
      futureText: '[PLACEHOLDER] Novas categorias de logos e símbolos em desenvolvimento.',
    },
    faq: {
      title: 'Perguntas frequentes',
      subtitle: 'Respondemos as dúvidas mais comuns sobre o jogo.',
      items: [
        { question: 'Para qual faixa etária é indicado?', answer: '[PLACEHOLDER] Faixa etária pendente de definição.' },
        { question: 'Quantos jogadores podem participar?', answer: '[PLACEHOLDER] Número de jogadores pendente de definição.' },
        { question: 'É difícil aprender a jogar?', answer: '[PLACEHOLDER] Nível de dificuldade e curva de aprendizado pendentes.' },
      ],
    },
    cta: {
      title: 'Tem interesse em Logo YA!?',
      text: 'Em breve disponível. Consulte pelo WhatsApp para receber novidades.',
      buttonText: 'Ver informações do produto',
    },
  },

  // Logo YA! — Página Comercial
  logoYaProduct: {
    hero: {
      title: 'Logo YA! — O jogo',
      subtitle: '[PLACEHOLDER] Descrição comercial do produto pendente de definição.',
      imageAlt: 'Logo YA! — Caixa do jogo',
      whatsAppBtn: 'Consultar pelo WhatsApp',
    },
    badges: {
      type: 'Jogo de Tabuleiro',
      status: 'Em breve',
    },
    price: {
      title: 'Reserve seu Logo YA!',
      subtitle: 'Em breve disponível. Você pode consultar ou reservar sua unidade agora.',
      statusBadge: 'Em breve',
      amountText: 'Preço em breve',
      amountSubtext: 'O preço definitivo será confirmado no lançamento.',
      features: [
        'Jogo de tabuleiro físico completo',
        'Instruções incluídas',
        'Envios para todo o país',
        'Atendimento pelo WhatsApp',
      ],
      whatsAppMessage: 'Olá! Tenho interesse em Logo YA! Quando estará disponível?',
      whatsAppBtn: 'Consultar pelo WhatsApp',
      footerNote: 'Sem compromisso de compra. Coordenamos tudo pelo WhatsApp.',
    },
    includes: {
      title: 'O que inclui Logo YA!?',
      subtitle: '[PLACEHOLDER] Conteúdo definitivo da caixa pendente de definição.',
      item1: '[PLACEHOLDER] Componente 1',
      item2: '[PLACEHOLDER] Componente 2',
      item3: '[PLACEHOLDER] Componente 3',
      item4: '[PLACEHOLDER] Componente 4',
    },
    gallery: {
      title: 'Galeria',
      subtitle: '[PLACEHOLDER] Fotos do produto em breve.',
      item1: '[PLACEHOLDER] Vista do jogo completo',
      item2: '[PLACEHOLDER] Detalhe dos logos',
      item3: '[PLACEHOLDER] Caixa do jogo',
    },
    faq: {
      title: 'Perguntas frequentes',
      subtitle: 'Respondemos as dúvidas mais comuns sobre a compra.',
      items: [
        { question: 'Quando estará disponível?', answer: '[PLACEHOLDER] Data de lançamento pendente de definição.' },
        { question: 'Como posso reservar minha unidade?', answer: 'Consulte pelo WhatsApp e te informamos do processo.' },
        { question: 'Fazem envios?', answer: 'Sim, enviamos para todo o país.' },
      ],
    },
  },
};

export default pt;
